export default __webpack_public_path__ + "assets/images/ignoredGroups-62be286e7fe85e50991587c22e051853.jpg";